/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findOneProgram } from '../fn/programs/find-one-program';
import { FindOneProgram$Params } from '../fn/programs/find-one-program';
import { listPublishedPrograms } from '../fn/programs/list-published-programs';
import { ListPublishedPrograms$Params } from '../fn/programs/list-published-programs';
import { Program } from '../models/program';

@Injectable({ providedIn: 'root' })
export class ProgramsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `programControllerListPublishedPrograms()` */
  static readonly ProgramControllerListPublishedProgramsPath = '/programs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listPublishedPrograms()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPublishedPrograms$Response(
    params?: ListPublishedPrograms$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<Program>>> {
    return listPublishedPrograms(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listPublishedPrograms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPublishedPrograms(params?: ListPublishedPrograms$Params, context?: HttpContext): Observable<Array<Program>> {
    return this.listPublishedPrograms$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Program>>): Array<Program> => r.body)
    );
  }

  /** Path part for operation `programControllerFindOneProgram()` */
  static readonly ProgramControllerFindOneProgramPath = '/programs/{programSlug}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findOneProgram()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneProgram$Response(
    params: FindOneProgram$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Program>> {
    return findOneProgram(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findOneProgram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneProgram(params: FindOneProgram$Params, context?: HttpContext): Observable<Program> {
    return this.findOneProgram$Response(params, context).pipe(map((r: StrictHttpResponse<Program>): Program => r.body));
  }
}
